import React, { useMemo } from 'react';
import { Thumbnail } from '@remotion/player';
import { CompositionConfig } from '@goldcast/player-config/src/types/RemotionPlayerConfigTypes/CompositionConfig';
import { getFallbackFPS } from '@goldcast/player-config/src/utils/fpsUtils';
import { SizeType } from '@goldcast/player-config/src/types/asset-types';
import { COMPOSITION_DIMENSIONS, VIDEO_QUALITY } from '@goldcast/player-config/src/constants/Remotion.constants';
import MainPlayer from '../MainPlayer';
import { RemotionUsage, RemotionUsageContextProvider } from '../RemotionUsageContext/RemotionUsageContext';
/**
 * Only use this component if you're showing one thumbnail at a time. or you want to play the preview.
 * If you have a list of thumbnail clips where you want to show the thumbnail then you may want to generate png and use that instead.
 * refer apps/content-studio/src/libs/thumbnail.ts
 */
const RemotionThumbnail: React.FC<{
  videoSize: SizeType;
  playerConfig: CompositionConfig;
  durationInFrames: number;
  frameToDisplay?: number;
}> = ({ videoSize, playerConfig, durationInFrames, frameToDisplay = 0 }) => {
  const { compositionHeight, compositionWidth } = useMemo(() => {
    const videoQuality = VIDEO_QUALITY.FULL_HD;
    const compositionHeight = COMPOSITION_DIMENSIONS[videoSize][videoQuality].HEIGHT;
    const compositionWidth = COMPOSITION_DIMENSIONS[videoSize][videoQuality].WIDTH;

    return {
      compositionHeight,
      compositionWidth
    };
  }, [videoSize]);

  if (!playerConfig) {
    return <div className="size-full"> Preview not available </div>;
  }

  return (
    <RemotionUsageContextProvider usage={RemotionUsage.THUMBNAIL} isSharedPage={false}>
      <Thumbnail
        component={MainPlayer}
        compositionHeight={compositionHeight}
        compositionWidth={compositionWidth}
        frameToDisplay={frameToDisplay}
        durationInFrames={Math.floor(durationInFrames)}
        fps={getFallbackFPS()}
        inputProps={{
          ...playerConfig,
          showPlayerFrames: false,
          onOutlineRelease: () => {},
          canEditCaptions: false,
          disableCaptionsDragging: true,
          disableCaptionsResize: true,
          canEditSpeakerLabel: false
        }}
        style={{
          width: '100%',
          height: '100%'
        }}
      />
    </RemotionUsageContextProvider>
  );
};

export default RemotionThumbnail;
